import { getProactiveDraftsStore } from '../store/store';
import type CopilotTelemetrySession from 'owa-copilot-telemetry/lib/CopilotTelemetrySession';

export function getCurrentProactiveDraftsTelemetrySession(): CopilotTelemetrySession | undefined {
    return getProactiveDraftsStore().currentTelemetrySession;
}
